import React, { Component } from 'react';
import ChartFastLayout
    from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/chart-component/chart-fast-layout';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';
import Menu from '@tencent/dui/lib/components/Menu';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import isEqual from 'lodash/isEqual';
import styles from '../index.css';
import { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';
import {
    IChartUIFastLayout,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/chart-component/chart-fast-layout/fast-layout-config';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';

interface IChartLayoutProps {
    hideMenu: () => void,
    menuManager: IMenuManager,
    selectionService?: ISelectionService;
}

interface IChartLayoutStates {
    layouts: IChartUIFastLayout[];
}

const COLUMNS = 2;
const ITEM_WIDTH = 80;
const ITEM_HEIGHT = 80;

export default class ChartLayoutMenu extends Component<IChartLayoutProps, IChartLayoutStates> {
    /**
     * 负责更新快速布局数据
     */
    private chartLayout: ChartFastLayout;

    public constructor(props, context) {
        super(props, context);

        this.state = {
            layouts: [],
        };
    }

    public componentDidMount(): void {
        this.updateChartLayout();
    }

    // eslint-disable-next-line camelcase
    public UNSAFE_componentWillReceiveProps(): void {
        this.updateChartLayout();
    }

    public render() {
        const { layouts } = this.state;
        if (layouts.length === 0) return null;

        const margin = 6;
        const paddingLR = 6;
        const menuWidth = (COLUMNS * (ITEM_WIDTH + (margin * 2))) + (paddingLR * 2) + 2;
        const menuStyle: React.CSSProperties = {
            display: 'flex', flexDirection: 'row', flexWrap: 'wrap',
            fontSize: '0px', width: menuWidth, paddingLeft: paddingLR,
            paddingRight: paddingLR, overflowY: 'hidden', boxSizing: 'border-box',
        };

        return (<div><Menu
            onClick={this.handleMenuClick}
            style={menuStyle}
            className={styles['menu-no-shadow']}>
            {
                layouts.map((itemData, index) => {
                    const { title, icon } = itemData;
                    const itemStyle: React.CSSProperties = {
                        width: ITEM_WIDTH, height: ITEM_HEIGHT, margin, padding: 0,
                        display: 'inline-block', boxSizing: 'border-box',
                    };
                    return (
                        <Tooltip
                            key={index}
                            title={title}
                            placement='bottom'
                            containerOffsetY={-10}
                            overlayStyle={{ zIndex: 99999 }}
                        >
                            <Menu.Item id={`${index}`} style={itemStyle}>
                                {
                                    <img className="fast-layout-item" style={{
                                        width: '100%',
                                        height: '100%',
                                        border: 'solid 1px rgba(0, 0, 0, 0.08)',
                                    }} src={icon}/>
                                }
                            </Menu.Item>
                        </Tooltip>
                    );
                })
            }
        </Menu></div>);
    }

    private handleMenuClick = (id: string, e) => {
        // 防止菜单关闭
        e.nativeEvent.stopImmediatePropagation();
        const index = Number(id);
        const item = this.state.layouts[index];
        this.chartLayout?.updateLayout(item.config);
    };

    /**
     * 更新chartLayout
     */
    private updateChartLayout() {
        const model = this.props.selectionService?.getSelectedModel();
        if (model?.type === UIModelType.CHART) {
            const chartModel = model as IChartModel;
            if (!this.chartLayout || this.chartLayout.getCurChartModel() !== chartModel
                || !isEqual(this.chartLayout.getType(), ChartFastLayout.getChartType(chartModel))) {
                this.chartLayout = new ChartFastLayout(chartModel);
                const { type, subType } = this.chartLayout.getType();
                this.setState({
                    layouts: ChartFastLayout.getChartLayoutConfigs(type, subType),
                });
            }
        }
    }
}
